<template>
    <b-modal
        id="confirm_modal"
        centered
        hide-header
        hide-footer
        no-close-on-backdrop
    >
        <span class="title-light">{{ title }}</span>
        <div class="content" v-html="content"></div>
        <div v-if="isConfirmed" class="one-button-section">
            <button class="go-home-button" @click="goHome()">
                {{ btnGoHometext }}
            </button>
        </div>
        <div v-else class="two-button-section">
            <button
                class="cancle-button"
                @click="$bvModal.hide('confirm_modal')"
            >
                {{ btnCancelText }}
            </button>
            <a class="confirm-link" @click="clickConfirm()">
                {{ btnConfirmText }}
            </a>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "ConfirmModal",
    props: {
        title: {
            type: String,
            require: true,
            default: "",
        },
        content: {
            type: String,
            require: true,
            default: "",
        },
        btnCancelText: {
            type: String,
            require: false,
            default: "แก้ไข/ยกเลิกภายหลัง",
        },
        btnConfirmText: {
            type: String,
            require: false,
            default: "ยืนยันการแก้ไข/ยกเลิก",
        },
        btnGoHometext: {
            type: String,
            require: false,
            default: "กลับสู่หน้าหลัก",
        },
        isConfirmed: {
            type: Boolean,
            require: false,
            default: false,
        },
    },
    methods: {
        goHome() {
            this.$bvModal.hide("confirm_modal");
            this.$router.push("/privacysettings");
        },
        clickConfirm() {
            this.$emit("clickConfirm");
            this.$bvModal.hide("confirm_modal");
        },
    },
};
</script>

<style lang="scss">
@import "@/style/_mixin.scss";
$primary-color: #65513e;
$secondary-color: salmon;
$bg-color: #dfdcd9;

#confirm_modal {
    .modal-content {
        text-align: center;
        .modal-body {
            padding: 24px 20px;
            .title {
                font-size: 18px;
                font-weight: bold;
                color: $color-text;
                margin-bottom: 8px;
            }
            .title-light {
                font-size: 18px;
                font-weight: bold;
                color: #b79377;
                margin-bottom: 8px;
            }
            .content {
                color: $color-text-light;
                margin: 8px 0 24px;
            }
            .one-button-section,
            .two-button-section {
                display: flex;
                flex-direction: column;
                column-gap: 10px;

                button {
                    flex-grow: 1;
                    height: 45px;
                    border-radius: 50px;
                    border: solid 1px $color-text;
                }
                .cancle-button,
                .go-home-button {
                    color: #fff;
                    background-color: $color-text;
                }

                .confirm-link {
                    color: $color-text;
                    margin-top: 20px;
                    text-decoration: underline;
                }
            }
        }
    }
}
</style>
